
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/16/solid';
import UserImg from '../../assets/user.png';

const Usertable = ({ data , loading , onEdit }) => {
  const T_Head = ["#","Name","Email","Role","JoiningDate","Action"];

  return (
    <div className="font-[sans-serif] overflow-x-auto">
     {loading ? (
  <table className="min-w-full bg-white dark:bg-darkgray">
    <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
      <tr className="!p-4">
        {T_Head.map((item, index) => (
          <th className="text-left p-4 text-sm md:text-lg font-bold text-white" key={index}>
            {item}
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {Array(10)
        .fill(0)
        .map((_, index) => (
          <tr key={index}>
            {T_Head.map((_, colIndex) => (
              <td key={colIndex} className="p-4 border-b border-gray-100 dark:border-gray-700 animate-pulse">
                <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
              </td>
            ))}
          </tr>
        ))}
    </tbody>
  </table>
) : (
  <>
    <table className="min-w-full bg-white">
      <thead className="bg-primaryPurple dark:bg-lightgrey whitespace-nowrap">
        <tr className="!p-4 ">
          {T_Head.map((item, index) => (
            <th className="text-left p-4 text-sm md:text-lg font-bold text-white" key={index}>
              {item}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="whitespace-nowrap">
        {
        data?.length === 0 ? 
          <tr className="bg-gray-50 dark:bg-gray-900">
                <td colSpan={6}>
                  <div className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
                    flex flex-col items-center justify-center
                    text-center gap-2">
                    <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-white">
                      No Users Found
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                      There are currently no user records to display.
                    </p>
                  </div>
                </td>
              </tr>
        :
        data?.map((item, index) => (
          <tr className="text-left even:bg-blue-50 dark:even:bg-gray-700 dark:bg-gray-800  text-gray-900 dark:text-gray-200 text-sm" key={index}>
            <td className="p-2  ">{index + 1}</td>
            <td className="p-2  ">
              <div className="flex items-center gap-3">
                <img
                  // src={`data:image/jpeg;base64,${item.IMAGE}`}
                  src={item?.IMAGEURL || UserImg}
                  className="w-12 h-12 rounded-full object-contain border-2 border-gray-400"
                />
                <span>{item.FIRSTNAME} {item.LASTNAME}</span>
              </div>
            </td>
            <td className=" ">{item.EMAIL}</td>
            <td className=" ">{item.ROLE_TITLE}</td>
            <td className="  ">
              {new Date(item.JOININGDATE).toLocaleDateString("en-GB")}
            </td>
            <td className='text-center'>
              <button className="mr-4" onClick={() => onEdit(item)} title="Edit">
                <PencilSquareIcon className="h-6 w-6 text-blue-500" />
              </button>
            </td>
            
          </tr>
        ))}
      </tbody>
    </table>
  </>
)}

    </div>
  );
};

export default Usertable;
